import { computed, ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import { storeToRefs } from 'pinia'
import useResearchCustomerStore from '../stores/useResearchCustomerStore'
import { usePulseResearchBridge } from './usePulseResearchBridge'
import { useCplugPulse } from '~/domain/shared/pulse/composables/useCplugPulse'

const ONBOARDING_NPS_WIDGET_ID = 'onboarding-nps-2026-08-26'
const ONBOARDING_NPS_ERP_VERSION = 'erp-v3'

export function useResearchCustomerPulse (): void {
  const route = useRoute()
  const store = useResearchCustomerStore()
  const { activeResearch } = storeToRefs(store)
  const pulseEnabled = ref(false)

  const pulseArmed = computed(() =>
    pulseEnabled.value && activeResearch.value?.researchId != null
  )

  async function refreshEligibility (): Promise<void> {
    const ok = await store.getActive()
    pulseEnabled.value = ok && (activeResearch.value?.shouldShow ?? false)
  }

  watch(
    () => route.fullPath,
    async () => {
      await refreshEligibility()
    },
    { immediate: true }
  )

  useCplugPulse({
    widgetId: ONBOARDING_NPS_WIDGET_ID,
    erpVersion: ONBOARDING_NPS_ERP_VERSION,
    requireTourCompleted: false,
    clearDismissedState: true,
    enabled: pulseEnabled
  })

  usePulseResearchBridge({
    armed: pulseArmed,
    onSubmitted: () => {
      pulseEnabled.value = false
    }
  })
}
